import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_KEY = '36f3afe64b07eb9a8fdf446b8319e2a8';
const BASE_URL = 'https://api.exchangeratesapi.io/v1/latest';

interface ExchangeRates {
	[key: string]: number;
}

interface ExchangeResponse {
	base: string;
	rates: ExchangeRates;
	date: string;
}

const fetchExchangeRates = async ({ baseCurrency, amount = 1 }: { baseCurrency: string; amount?: number }): Promise<ExchangeResponse> => {
	// If ZWL is selected, fetch USD rates instead
	const actualBaseCurrency = baseCurrency === 'ZWL' ? 'USD' : baseCurrency;

	const response = await axios.get(BASE_URL, {
		params: {
			access_key: API_KEY,
			base: actualBaseCurrency,
			amount: amount
		}
	});

	// If ZWL was selected, modify the response to show ZWL as base
	if (baseCurrency === 'ZWL') {
		return {
			...response.data,
			base: 'USD'
		};
	}

	// console.log(response.data, "response.data");

	return response.data;
};

const getCountryCode = (currencyCode: string): string => {
	const exceptions = {
		EUR: 'EU',
		GBP: 'GB',
		USD: 'US',
		// Add more exceptions as needed
	};

	if (exceptions[currencyCode as keyof typeof exceptions]) {
		return exceptions[currencyCode as keyof typeof exceptions];
	}

	// For most currencies, the first two letters represent the country code
	return currencyCode.slice(0, 2);
};

export const useExchangeRates = (baseCurrency: string, receiveCurrency: string, amount = 1) => {
	return useQuery({
		queryKey: ['exchangeRates', baseCurrency, amount],
		queryFn: () => fetchExchangeRates({ baseCurrency, amount }),
		enabled: !!baseCurrency,
		staleTime: 5 * 60 * 1000,
		refetchOnWindowFocus: false,
		select: (data) => {
			if (data && data.rates) {
				const currencyList = Object.keys(data.rates).map(code => {
					const countryCode = getCountryCode(code);
					return {
						code,
						name: new Intl.DisplayNames(['en'], { type: 'currency' }).of(code),
						flag: `https://flagcdn.com/40x30/${countryCode.toLowerCase()}.webp`,
						flagAlt: `Flag of ${countryCode}`
					};
				});

				// Fix: Correctly extract the exchange rate for the receiving currency
				const receiveRate = data.rates[receiveCurrency];
				const initialReceived = receiveRate ? Number(receiveRate) * amount : 0;

				// Always make rates.ZWL equal to rates.USD
				let modifiedRates = { ...data.rates };
				if (modifiedRates.USD !== undefined) {
					modifiedRates.ZWL = modifiedRates.USD;
				}

				const i = {
					...data,
					initialReceived,
					currencyList,
					rates: modifiedRates
				};
				console.log(i, "1");
				return i;
			}

			return data;
		}
	});
};
